export default __webpack_public_path__ + "assets/audio/ssml/speak.499398ea83687b084f8ddb67f33bbd3f.mp3";